import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateStatus = ({ dpsID, status }) => {
  try {
    return axios.put(
      `/api/dps/${dpsID}/status`,
      JSON.stringify({ Status: status })
    );
  } catch (error) {
    return error;
  }
};

export const useUpdateStatus = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateStatus,
    onSuccess: () => {
      enqueueSnackbar('Status successfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
